import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ApiBase } from '../api-base';

export interface AssociationMemberDto {
    id: string;
    email: string;
    role: 'Manager' | 'Contact';
    isAccepted: boolean;
}

// Organizer-facing association member management, scoped under the event/group
// (authorized via event edit permission, not AssociationRole.Manager like AssociationApi).
@inject(IHttpClient)
export class GroupAssociationMembersApi extends ApiBase {
    constructor(http: IHttpClient) {
        super(http);
    }

    public async getMembers(eventId: string, groupId: string, associationId: string): Promise<AssociationMemberDto[]> {
        const r = await this.get(this._url(eventId, groupId, associationId));
        return (r.content as AssociationMemberDto[]) ?? [];
    }

    // Additive-only: ensures each email has a pending Contact invite; never removes existing members.
    public async syncMembers(eventId: string, groupId: string, associationId: string, emails: string[]): Promise<AssociationMemberDto[]> {
        const r = await this.post(this._url(eventId, groupId, associationId), { emails });
        return (r.content as AssociationMemberDto[]) ?? [];
    }

    public async removeMember(eventId: string, groupId: string, associationId: string, memberId: string): Promise<void> {
        await this.delete(`${this._url(eventId, groupId, associationId)}/${memberId}`);
    }

    private _url(eventId: string, groupId: string, associationId: string): string {
        return `api/events/${eventId}/groups/${groupId}/associations/${associationId}/members`;
    }
}
